/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { FormLayout, TextStyle, Link, Icon } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';

import { Field } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { DropdownIndicator, styles } from './react-select-style';
import { RenderSelect2 } from 'src/components/views/common/forms/render-select-2-v2';
import { VIEW_AS_OPTIONS_BY_THEME } from 'src/constants/theme-settings.js';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  boostThemeLibName: string,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ToolBarViewAsForm extends Component<ComposedProps> {
  state = {};

  render() {
    const { i18n, prefix, boostThemeLibName = 'default' } = this.props;

    const listTypeOptions = VIEW_AS_OPTIONS_BY_THEME[boostThemeLibName].map(option => {
      const { label, value } = option;
      return { label: i18n.translate(label), value };
    });

    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.toolBar_ViewAs_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['ToolbarViewAsThemeSetting']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <div className="form-section">
          <div className="form-section__item">
            <Field
              name={`${prefix}.listType`}
              component={RenderSelect2}
              options={listTypeOptions}
              label={i18n.translate('AdminHTML.ThemeSetting.Form.toolBar_ViewAs_ListType_Label')}
              components={{ DropdownIndicator }}
              styles={styles}
            />
          </div>
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ToolBarViewAsForm);
